import axios from 'axios';

const request = axios.create(
  {
    //baseURL:'https://mobile.test-cignacmb.com',
    baseURL:'/',
    timeout:5000
  }
);

request.interceptors.request.use(
  config => {
    //config.headers['Content-Type'] = 'application/json;charset=utf-8';
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    return config;
  },error =>{
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (res)=>{
    return res.data;
  },(err) => {
    //alert(0;)
    //return err;
  }
);

export default request;